import {CONST} from "../config/CONST";

export const footerMenu = (function ($) {

    var $DOM = {};

    function init(footerMenuItems) {

        $DOM.footer = $("footer");
        $DOM.nav = $DOM.footer.find(".footer__navrow");


        renderMenu(footerMenuItems);

    }

    function renderMenu(menuItems) {

        const columns = [
            ['FOND'],
            ['CONS', 'BLOG'],
            ['FAQ'],
            ['STRU'],
            ['WHOIS', 'CONT'],
            ['OTHER']
        ];
        const cookieLink = '<ul><li><a role="button" tabindex="0" class="cli_settings_button">Impostazioni Cookies</a></li></ul>';
        const socialLinks = $(".footer__social").html();
        $DOM.nav.find(".row").empty();

        columns.forEach((column, i) => {

            const $col = $('<div class="col-md-4 col-lg-2"/>');
            if(i === columns.length - 1) {
                $col.append(socialLinks);
            }

            column.forEach((colGgroup) => {

                const menuGroup = menuItems.find(i => i.CODICE === colGgroup);
                const $menuGroup = $('<div/>');

                if(menuGroup.DESCR && menuGroup.DESCR !== '') {
                    $menuGroup.append('<h6 class="toggle">' + menuGroup.DESCR + '</h6>');
                }

                if(menuGroup.FOGLIE && Array.isArray(menuGroup.FOGLIE)) {
                    const $menuGroupUl = $('<ul/>');
                    menuGroup.FOGLIE.forEach((colGroupItem) => {
                        let itemUrl =
                            (colGroupItem.URL.includes('tel:') || colGroupItem.URL.includes('mailto:'))
                                ? colGroupItem.URL
                                : `${CONST.dynamicHeader.mainSiteBaseUrl}/${colGroupItem.URL}`
                        ;
                        $menuGroupUl.append('<li><a href="' + itemUrl + '">' + colGroupItem.DESCR + '</a></li>')
                    })
                    $menuGroup.append($menuGroupUl);
                }

                $col.append($menuGroup.html());


            });

            $DOM.nav.find(".row").append($col);
            if(i === columns.length - 1) {
                $col.append(cookieLink);
            }


        });


        navInit();
    }

    function navInit() {

        $DOM.navMenuLev1Items = $DOM.nav.find("h6");

        // FRANCESCA
        // duplicateItemsForMobileMenu();

        $DOM.footer.find("h6.toggle").on("click", function(e) {
            if($(window).width() < 576) {
                e.preventDefault();
                $(this).toggleClass("is-open");
                var $submenu = $(this).next("ul");
                $submenu.slideToggle();
            }
        });
    }

    /*
    function duplicateItemsForMobileMenu() {
        $DOM.navMenuLev1Items.each(function () {
            var $link = $(this).children("a");
            if ($link.length === 0)
                return;
            var $cloned = $link.clone();
            var $submenu = $(this).siblings("ul");
            var $li = $("<li/>");
            $li.append($cloned);
            $li.addClass("d-md-none").addClass("d-lg-none").addClass("d-xl-none");
            $submenu.prepend($li);
        });
    }
    */

    return {
        init: init
    }

})(jQuery);